import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancer-hospitals',
  templateUrl: './cancer-hospitals.component.html',
  styleUrls: ['./cancer-hospitals.component.css']
})
export class CancerHospitalsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.documentElement.scrollTop = 0;
  }

}
